import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { JBMSelectOption } from 'src/app/components/JBM/Forms/JBMFormGroups/JBMSelect/JBMSelect.component';

import { ModalService } from 'src/app/components/JBM/JBMModal/service/modal.service';
import { TranslateService } from 'src/app/services/multilingual/translate.service';
import { UserPreferencesService, UserPreferences } from 'src/app/services/storage/user_preferences.service';
import { EventService } from 'src/app/services/event.service';

@Component({
   selector: 'user-settings',
   templateUrl: './userPreferences.component.html',
   styleUrls: ['./userPreferences.component.scss']
})
export class UserPreferencesComponent implements OnInit {
   title: string = ''
   form: FormGroup;
   isSubmitted: boolean = false;
   preferences: UserPreferences = this.UserPreferencesService.getDefault()
   entityIDdisplayOptions: JBMSelectOption[] = []

   @ViewChild('modalUserPreferences') modalUserPreferences: ElementRef;

   constructor(
      private Router: Router,
      private formBuilder: FormBuilder,
      private ModalService: ModalService,
      private TranslateService: TranslateService,
      private UserPreferencesService: UserPreferencesService,
      private EventService: EventService) {

      this.title = this.TranslateService.GetTranslation('entity.users') + this.TranslateService.GetTranslation('ui.preferences').toLowerCase()

      this.addControls();
   }
   ngOnInit(): void {
      this.entityIDdisplayOptions.push({ key: '0', value: this.TranslateService.GetTranslation('ui.dont-show') })
      this.entityIDdisplayOptions.push({ key: '1', value: this.TranslateService.GetTranslation('preferences.entity-id-display-after') })
      this.entityIDdisplayOptions.push({ key: '2', value: this.TranslateService.GetTranslation('preferences.entity-id-display-before') })

      this.UserPreferencesService.get().subscribe(
         (result: any) => {
            this.preferences = result
            this.setControlValues()   
         }, (error: any) => console.error(error)
      )
      setTimeout(() => this.ModalService.open(this.modalUserPreferences, 'user-preferences'), 100);
   }
   addControls() {
      this.form = this.formBuilder.group({
         IDdisplay: new FormControl('', [Validators.required])
      }, { updateOn: "blur" });
   }

   get formControls() { return this.form.controls; }

   setControlValues() {
      this.formControls['IDdisplay'].setValue(this.preferences.display.IDdisplay.toString())
   }
   changeEntityIDdisplay(event: any) {
      if(typeof this.preferences === 'boolean') return
      this.preferences.display.IDdisplay = parseInt(event.target.value)
   }
   save() {
      this.isSubmitted = true;

      if (this.form.invalid)
         return;

      this.preferences.display.IDdisplay = parseInt(this.formControls['IDdisplay'].value)
      this.UserPreferencesService.set(this.preferences).subscribe({
         next: () => {
            this.EventService.emit('userpreferences')
            this.close()
         }, error: (error: any) => console.error(error)
      })
   }
   close() {
      this.Router.navigate([{ outlets: { 'modal': null } }]);
   }
}
